import { render, staticRenderFns } from "./Bullet.vue?vue&type=template&id=44eaa0a5"
import script from "./Bullet.vue?vue&type=script&lang=js"
export * from "./Bullet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports